var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReview = function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 1.708v1.677a6.668 6.668 0 1 0 4.921 11.882l1.186 1.186A8.333 8.333 0 1 1 9.166 1.709Zm9.125 9.125a8.29 8.29 0 0 1-1.84 4.44l-1.185-1.185a6.635 6.635 0 0 0 1.348-3.255h1.678-.001Zm-7.457-9.125a8.336 8.336 0 0 1 7.458 7.459h-1.677a6.67 6.67 0 0 0-5.781-5.782V1.708Z",
    fill: "currentColor"
  })));
};
export default SvgReview;